import {
	modalAdd
} from "./modalAdd";

export function casseroleRound(productId) {
	// 変数名は型番
	// round 10cm
	const LV10RM = {
		rotateClass: "",
		class: "",
		cm: "10cm",
		en: "LAVA ROUND CASSEROLE",
		jp: "ラヴァ ラウンドキャセロール",
		price: "4,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/img_round10_modal.png",
		size: "10cm",
		capacity: "0.35L",
		amount: "1人前",
		diameterText: "直径",
		diameter: "11.0cm",
		width: "15.0cm",
		height: "7.0cm",
		weight: "1.0kg",
		bottom: "3.5mm",
		edge: "3.0mm",
		number: "LV10RM",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv10rm/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv10rm.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round.jpg",
		note: "※横と高さは、蓋のツマミ、本体の取っ手を含む"
	};

	// round 14cm
	const LV14RM = {
		rotateClass: "",
		class: "",
		cm: "14cm",
		en: "LAVA ROUND CASSEROLE",
		jp: "ラヴァ ラウンドキャセロール",
		price: "7,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/img_round14_modal.png",
		size: "14cm",
		capacity: "0.75L",
		amount: "1-2人前",
		diameterText: "直径",
		diameter: "15.0cm",
		width: "19.0cm",
		height: "7.5cm",
		weight: "2.1kg",
		bottom: "5.0mm",
		edge: "4.0mm",
		number: "LV14RM",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv14rm/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv14rm.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round.jpg",
		note: "※横と高さは、蓋のツマミ、本体の取っ手を含む"
	};

	// round 18cm
	const LV18RM = {
		rotateClass: "",
		class: "",
		cm: "18cm",
		en: "LAVA ROUND CASSEROLE",
		jp: "ラヴァ ラウンドキャセロール",
		price: "10,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/img_round18_modal.png",
		size: "18cm",
		capacity: "1.7L",
		amount: "1-2人前",
		diameterText: "直径",
		diameter: "19.0cm",
		width: "25.5cm",
		height: "9.0cm",
		weight: "2.9kg",
		bottom: "5.0mm",
		edge: "4.0mm",
		number: "LV18RM",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv18rm/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv18rm.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round.jpg",
		note: "※横と高さは、蓋のツマミ、本体の取っ手を含む"
	};

	// round 20cm
	const LV20RM = {
		rotateClass: "",
		class: "",
		cm: "20cm",
		en: "LAVA ROUND CASSEROLE",
		jp: "ラヴァ ラウンドキャセロール",
		price: "13,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/img_round20_modal.png",
		size: "20cm",
		capacity: "2.8L",
		amount: "2-3人前",
		diameterText: "直径",
		diameter: "21.0cm",
		width: "28.0cm",
		height: "11.5cm",
		weight: "4.3kg",
		bottom: "5.0mm",
		edge: "4.0mm",
		number: "LV20RM",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv20rm/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv20rm.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round.jpg",
		note: "※横と高さは、蓋のツマミ、本体の取っ手を含む"
	};

	// round 24cm
	const LV24RM = {
		rotateClass: "",
		class: "",
		cm: "24cm",
		en: "LAVA ROUND CASSEROLE",
		jp: "ラヴァ ラウンドキャセロール",
		price: "16,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/img_round24_modal.png",
		size: "24cm",
		capacity: "4.5L",
		amount: "4-5人前",
		diameterText: "直径",
		diameter: "25.0cm",
		width: "32.0cm",
		height: "12.5cm",
		weight: "5.8kg",
		bottom: "5.0mm",
		edge: "4.0mm",
		number: "LV24RM",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv24rm/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv24rm.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round.jpg",
		note: "※横と高さは、蓋のツマミ、本体の取っ手を含む"
	};

	// round 28cm
	const LV28RM = {
		rotateClass: "",
		class: "",
		cm: "28cm",
		en: "LAVA ROUND CASSEROLE",
		jp: "ラヴァ ラウンドキャセロール",
		price: "19,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/img_round28_modal.png",
		size: "28cm",
		capacity: "6.7L",
		amount: "6-8人前",
		diameterText: "直径",
		diameter: "29.0cm",
		width: "36.0cm",
		height: "13.5cm",
		weight: "7.8kg",
		bottom: "5.0mm",
		edge: "4.0mm",
		number: "LV28RM",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv28rm/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv28rm.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round.jpg",
		note: "※横と高さは、蓋のツマミ、本体の取っ手を含む"
	};

	// round 32cm
	const LV32RM = {
		rotateClass: "",
		class: "",
		cm: "32cm",
		en: "LAVA ROUND CASSEROLE",
		jp: "ラヴァ ラウンドキャセロール",
		price: "23,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/img_round32_modal.png",
		size: "32cm",
		capacity: "9.8L",
		amount: "8-12人前",
		diameterText: "直径",
		diameter: "33.0cm",
		width: "41.0cm",
		height: "15.0cm",
		weight: "9.6kg",
		bottom: "5.0mm",
		edge: "4.0mm",
		number: "LV32RM",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv32rm/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv32rm.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_round.jpg",
		note: "※横と高さは、蓋のツマミ、本体の取っ手を含む"
	};

	switch (productId) {
		case "LV10RM": {
			modalAdd(LV10RM);
			break;
		}
		case "LV14RM": {
			modalAdd(LV14RM);
			break;
		}
		case "LV18RM": {
			modalAdd(LV18RM);
			break;
		}
		case "LV20RM": {
			modalAdd(LV20RM);
			break;
		}
		case "LV24RM": {
			modalAdd(LV24RM);
			break;
		}
		case "LV28RM": {
			modalAdd(LV28RM);
			break;
		}
		case "LV32RM": {
			modalAdd(LV32RM);
			break;
		}
	}
}